import { REMOVE_PROPERTY, RESET_REMOVE_PROPERTY } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, BaseAsyncReducerState } from "../../types";

// Define an initial state value for the app
const initialState: BaseAsyncReducerState = {
    loading: false,
    error: false
}
  
function removePropertyReducer(state = initialState, action: AppAction) {

    const { payload } = action;

    switch (action.type) {
        case REMOVE_PROPERTY.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case REMOVE_PROPERTY.SUCCESS:

            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false,

            }

        case REMOVE_PROPERTY.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case RESET_REMOVE_PROPERTY:
            return {
                ...initialState
            }
        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default removePropertyReducer;